import { render, staticRenderFns } from "./InviteUsersTableItem.vue?vue&type=template&id=f87cb51e&scoped=true&"
import script from "./InviteUsersTableItem.vue?vue&type=script&lang=ts&"
export * from "./InviteUsersTableItem.vue?vue&type=script&lang=ts&"
import style0 from "./InviteUsersTableItem.vue?vue&type=style&index=0&id=f87cb51e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87cb51e",
  null
  
)

export default component.exports